import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { evidenceRegistersApi, templateApi } from '../services/api';
import { RegisterManagementPage } from './RegisterManagementPage';
import type { Template } from '../types/models';

export const EvidenceRegistersPage: React.FC = () => {
  // Fetch templates dynamically from the API
  const { data: templatesData } = useQuery({
    queryKey: ['templates', 'evidence'],
    queryFn: () => templateApi.list('evidence'),
  });

  // Convert templates to dropdown options (only show active templates)
  const templates = templatesData
    ?.filter((t: Template) => t.isActive)
    .map((t: Template) => ({
      value: t.templateName,
      label: t.displayName,
    })) || [];

  // Determine default template (first active template, or fallback)
  const defaultTemplate = templates.length > 0 ? templates[0].value : 'comprehensive';

  return (
    <RegisterManagementPage
      title="Evidence Registers"
      iconClass="ri-folder-line"
      queryKey="evidenceRegisters"
      api={evidenceRegistersApi}
      includeDepartments
      templates={templates}
      defaultTemplate={defaultTemplate}
      listPath="/evidence"
      configPath="/evidence-config"
      applyTemplateKind="evidence"
      countField="evidenceCount"
      countLabel="Evidence"
      allowForceDelete
    />
  );
};
